export default __webpack_public_path__ + "static/media/access-cyan-bg.5b695206.svg";